/**
 * Logika progress pekerjaan fisik berdasarkan jenis bantuan.
 */

function normalizeJenis(jenis) {
  return String(jenis || '').toLowerCase().trim();
}

// Semua jenis "Rehab" (layak huni maupun tidak layak huni) menggunakan
// langkah yang diisi sendiri (manual) oleh TFL/Admin, presentase dari anggaran.
export function isFisikManualRehab(jenis) {
  return normalizeJenis(jenis).includes('rehab');
}

// Jenis "Pembangunan" menggunakan template tahap default (bobot tetap).
export function isFisikPembangunan(jenis) {
  return normalizeJenis(jenis).includes('pembangunan');
}

export function isFisikDefaultRtlh(jenis) {
  const j = normalizeJenis(jenis);
  return j.includes('tidak layak') || j.includes('rehab rumah tidak') || j.includes('rombak');
}

export function calcFisikPresentase(steps, jenisBantuan, nominalMaterial) {
  if (!steps?.length) {
    return { presentase: 0, langkahSelesai: 0, totalLangkah: 0, totalAnggaran: 0, totalMaterial: 0, mode: 'empty' };
  }

  const totalMaterial = Number(nominalMaterial) || 0;
  const langkahSelesai = steps.filter((l) => l.status === 'Selesai').length;

  if (isFisikManualRehab(jenisBantuan) && totalMaterial > 0) {
    const totalAnggaran = steps
      .filter((l) => l.status === 'Selesai')
      .reduce((sum, l) => sum + (Number(l.anggaran) || 0), 0);
    return {
      presentase: Math.min(100, Math.round((totalAnggaran / totalMaterial) * 100)),
      langkahSelesai,
      totalLangkah: steps.length,
      totalAnggaran,
      totalMaterial,
      mode: 'manual_rehab',
    };
  }

  if (isFisikDefaultRtlh(jenisBantuan) && totalMaterial > 0) {
    const totalPenggunaan = steps.reduce((sum, l) => sum + (Number(l.anggaranPenggunaan) || 0), 0);
    return {
      presentase: Math.min(100, Math.round((totalPenggunaan / totalMaterial) * 100)),
      langkahSelesai,
      totalLangkah: steps.length,
      totalAnggaran: totalPenggunaan,
      totalMaterial,
      mode: 'default_rtlh',
    };
  }

  const totalBobot = steps.reduce((s, l) => s + (Number(l.bobot) || 0), 0);
  if (totalBobot > 0) {
    const bobotSelesai = steps
      .filter((l) => l.status === 'Selesai')
      .reduce((s, l) => s + (Number(l.bobot) || 0), 0);
    return {
      presentase: Math.round((bobotSelesai / totalBobot) * 100),
      langkahSelesai,
      totalLangkah: steps.length,
      totalAnggaran: 0,
      totalMaterial,
      mode: 'bobot',
    };
  }

  return {
    presentase: Math.round((langkahSelesai / steps.length) * 100),
    langkahSelesai,
    totalLangkah: steps.length,
    totalAnggaran: 0,
    totalMaterial,
    mode: 'count',
  };
}

// Alias agar kompatibel dengan modul yang masih memanggil calcFisikPercent
export const calcFisikPercent = calcFisikPresentase;

export function getFisikModeLabel(jenis) {
  if (isFisikManualRehab(jenis)) return 'Manual (Rehab)';
  if (isFisikPembangunan(jenis)) return 'Default (Pembangunan)';
  if (isFisikDefaultRtlh(jenis)) return 'Default (Rumah Tidak Layak Huni)';
  return 'Standar (Bobot)';
}
